const isProd = window.location.hostname === 'anhdigital.ai';

export const BRAND_NAME = isProd ? 'ANH Digital' : 'ANH Digital Barnyard';
export const BRAND_SHORT = isProd ? 'Digital' : 'Barnyard';
export const BRAND_TITLE = isProd ? 'ANH Digital Platform' : 'ANH Barnyard';
